<template>
	<div>
		<div style="background:#00A6E5;display: flex;justify-content: center;">
			<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;align-items: center;">
					<span style="font-size: 28px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 40px;margin-left: 14px;">我要跟单</span>
				</div>
				<div @click="goBack" style="width: 80px;height: 36px;border-radius: 4px;border: 1px solid #FFFFFF;display: flex;align-items: center;justify-content: space-around;cursor: pointer;">
					<span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;
				">返回</span>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;">
			<div style="width: 60%;">
				<div style="display: flex;flex-direction:column;align-items:center;background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;margin-top: 30px;padding: 70px 30px 20px 30px;margin-bottom: 30px;">
					<div class="item_row">
						<span class="item_name">牛人名称</span>
						<input class="input_val" type="text" :value="item.nick_name" readonly="true">
					</div>
					<!-- <div class="item_row">
						<span class="item_name">牛人账号</span>
						<input class="input_val" type="text" :value="item.account" readonly="true"  >
					</div> -->
					<div class="item_row">
						<span class="item_name">MT5账号</span>
						<input class="input_val" type="text" placeholder="请输入账号" v-model="account">
					</div>
					<div class="item_row">
						<span class="item_name">账户类型</span>
						<select class="input_val"  v-model="type">
							<option value="">请选择账户类型</option>
						    <option value="标准账户">标准账户</option>
						    <option value="ECN账户">ECN账户</option>
						</select>
					</div>
					<div class="item_row">
						<span class="item_name">MT5密码</span>
						<input class="input_val" type="password" placeholder="请输入账号密码" v-model="passwd">
					</div>
					<div class="item_row">
						<span class="item_name">邮箱</span>
						<input class="input_val" type="email" placeholder="请输入邮箱" v-model="email">
					</div>
					<div class="item_row" style="position: relative;">
						<span class="item_name">MT5跟单比例</span>
						<input class="input_val" type="number" placeholder="请输入跟单比例（100表示100%）" v-model="multiple">
						<span style="position: absolute;right: 40px;">&nbsp;&nbsp;&nbsp;%</span>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 60px;">
						<button @click="postInfo" style="width: 240px;height: 50px;background: #00A6E5;border-radius: 4px;font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;border: none;cursor: pointer;">提交</button>
					</div>
					<div style="margin-top: 72px; margin-bottom: 101px;">
						<span style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #666666;line-height: 20px;">注意事项</span>
						<div>
							<span style="margin-top:16px;font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;line-height: 17px;">
								1.如果您尚未注册MT5账号，请先注册账户后再提交申请。<br>
								2.在使用跟单系统前，应确认已熟知跟单系统的各项操作原理，跟单及平仓操作属于个人行为，与所属平台商无关。<br>
								3.客户在使用跟单系统进行跟单时，应仔细了解信号源详情，谨慎选择适合自身投资能力和风险承受能力的信号源。<br>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		HOST,
		IMG_HOST
	} from '../Api.js'
	export default {
		name: 'Follow',
		props: {
			msg: String
		},
		data() {
			return {
				type:'',
				item: {},
				account: '',
				passwd: '',
				email: '',
				multiple: 100,
			}
		},
		mounted() {
			if (this.$route.params.data) {
				localStorage.setItem('FLDATA', JSON.stringify(this.$route.params.data));
				this.item = this.$route.params.data;
			} else {
				this.item = JSON.parse(localStorage.getItem('FLDATA'));
			}
			this.loadData();
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			loadData() {

			},
			postInfo() {
				let postData = {};
				postData.account = this.account;
				postData.passwd = this.passwd;
				postData.email = this.email;
				postData.multiple = this.multiple;
				postData.follow = this.item.account;
				postData.type = this.type;
				console.log(postData);
				if (postData.account == '') {
					this.$layer.msg('请输入账号', {
						time: 2
					});
					return;
				}
				if(postData.type == ''){
					this.$layer.msg('请选择账户类型',{
						time:2
					});
					return;
				}
				if (postData.passwd == '') {
					this.$layer.msg('请输入密码', {
						time: 2
					});
					return;
				}
				if (postData.email == '') {
					this.$layer.msg('请输入邮箱', {
						time: 2
					});
					return;
				}
				if (postData.multiple == '') {
					this.$layer.msg('请输入跟单比例', {
						time: 2
					});
					return;
				}
				this.$layer.confirm('确定跟单吗?', {
					btn: ['确定', '取消']
				}, () => {

					this.$layer.closeAll();
					this.$layer.loading({
						content: '请求中'
					});
					fetch(HOST + 'biggun/follow', {
						method: 'POST',
						headers: {
							"Content-Type": "application/json;charset=utf8"
						},
						body: JSON.stringify(postData)
					}).then(response => response.json()).then(res => {
						this.$layer.closeAll();
						if (res.errcode === '0000') {
							this.$router.push({
								name: 'SubmitSuccess',
								params: {
									type: 2
								}
							});
						} else {
							this.$layer.msg(res.errmsg, {
								time: 2
							});
						}
					})
				}, () => {
					this.$layer.closeAll();
				})


			}
		}
	}
</script>

<style scoped>
	.top_block {
		height: 200px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
		border-radius: 4px;
		margin-top: 30px;
	}

	.img_left_block {
		display: flex;
		align-items: center;
	}

	.top_top {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px 40px 30px;
	}

	.tips_item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tips_str {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 18px;
	}

	.tips_val {
		font-size: 16px;
		font-family: Helvetica;
		color: #333333;
		line-height: 19px;
		margin-top: 6px;
	}

	.title_bar {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}

	.table_all {
		width: 100%;
		border: 1px solid #EDEFF1;
		border-collapse: collapse;
		border-spacing: 0px;
		margin-top: 20px;
	}

	.table_all th {
		background: #F1F5F7;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 48px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;

	}

	.table_all td {
		background: #FFFFFF;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 54px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
	}

	.item_row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 60%;
		margin-top: 20px;
	}

	.item_name {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
		flex: 2;
	}

	.input_val {
		background: #FFFFFF;
		border-radius: 3px;
		border: 1px solid #CED4DA;
		flex: 8;
		padding: 9px 16px 9px 16px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
	}
</style>
